import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { map } from 'rxjs/operators';

export const sortReferenceItemsByControlTypeId = map((items: RefTypeItem[]) => {
  const sortedTypes = [
    ...items.filter(ref => ref.controlId).sort(compareRefControlId),
    ...items.filter(ref => !ref.controlId)
  ];
  return sortedTypes;
});

// sort func. for refType controlId
export const compareRefControlId = (a: RefTypeItem, b: RefTypeItem) => {
  return a.controlId && b.controlId ? a.controlId - b.controlId : 0;
};

export const getDefaultRefId = (
  refItems: RefTypeItem[],
  defaultValue: number | null = null
): number | null => {
  const defaultCategory = refItems.find(
    refItem => refItem.extendedProperties?.isDefault?.toLowerCase() === 'true'
  );

  if (defaultCategory) {
    return defaultCategory.id;
  }

  return defaultValue;
};
